"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classnames = _interopRequireDefault(require("classnames"));

var TypingIndicator = function TypingIndicator() {
  return (0, _preact.h)("div", {
    className: "forethought-agent__turn forethought-agent__turn--agent",
    "aria-live": "polite",
    "aria-label": "Agent is typing"
  }, (0, _preact.h)("div", {
    className: (0, _classnames.default)('forethought-agent__bubble', 'forethought-agent__bubble--agent', 'forethought-agent__bubble--typing')
  }, (0, _preact.h)("span", {
    className: "forethought-agent__typing",
    "aria-hidden": "true"
  }, (0, _preact.h)("span", {
    className: "forethought-agent__typing-dot"
  }), (0, _preact.h)("span", {
    className: "forethought-agent__typing-dot"
  }), (0, _preact.h)("span", {
    className: "forethought-agent__typing-dot"
  }))));
};

var _default = TypingIndicator;
exports.default = _default;